import Ad from "./ad";
import Campaigns from "./campaigns";
import "./style.scss";

const HomePage = () => {
  return (
    <div className="homepage">
      <Ad />

      <Campaigns />
      {/* <Filter />
      <FilterResponsive /> */}
    </div>
  );
};
export default HomePage;
